import { PillSearchBar } from "@/components/common/PillSearchBar";
import type { EmployeeSummary } from "@/hooks/useMakersBoardData";
import { getEmployeeDisplayName } from "@/utils/nameUtils";

interface EmployeeSearchProps {
  pills: string[];
  onPillsChange: (pills: string[]) => void;
  inputValue: string;
  onInputChange: (value: string) => void;
  placeholder?: string;
}

export function EmployeeSearch({
  pills,
  onPillsChange,
  inputValue,
  onInputChange,
  placeholder = "Search employees...",
}: EmployeeSearchProps) {
  return (
    <PillSearchBar
      pills={pills}
      onPillsChange={onPillsChange}
      inputValue={inputValue}
      onInputChange={onInputChange}
      placeholder={placeholder}
    />
  );
}

export function getMatchScore(employee: EmployeeSummary, query: string): number {
  const lowerQuery = query.trim().toLowerCase();
  if (!lowerQuery) return 0;
  const name = getEmployeeDisplayName(employee).toLowerCase();
  const canonicalName = (employee.name ?? "").toLowerCase();

  if (name.startsWith(lowerQuery)) return 100;
  if (name.includes(lowerQuery)) return 80;
  if (canonicalName.startsWith(lowerQuery)) return 60;
  if (canonicalName.includes(lowerQuery)) return 40;

  return 0;
}
